@if (shouldShow && isAllowedToBeSeen && show) {
  <table class="full_width" style="line-height: 1.4; margin-top: 0.5%">
    @if (textIndent) {
      <tr [style.text-indent]="textIndent">
        <!-- Name of Parameter on the left side -->
        <td [style.width]="(leftColumnWidth ?? 50)  + '%'" class="align_left">
          @if (displayName) {
            {{ displayName }}
          }
        </td>
        <!-- Value of Parameter on the right side -->
        @if (displayValue) {
          <td [style.width]="(leftColumnWidth ?? 50)  + '%'" class="align_right">
            <!-- 'Normal' line, name and value  -->
            <ng-container>{{ displayValue }}</ng-container>
          </td>
        }
      </tr>
    }
  </table>
}
